/* eslint-disable no-console */
const LOG_PREFIX = '[ADVERT] Native Renderer:';

export default {
	log: (...args: unknown[]) => console.log(LOG_PREFIX, ...args),
	warn: (...args: unknown[]) => console.warn(LOG_PREFIX, ...args),
	error: (...args: unknown[]) => console.error(LOG_PREFIX, ...args),
};
